import {
  Component,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'dx-default-window',
  templateUrl: './default-window.component.html',
  styleUrls: ['./default-window.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultWindowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
